import React from 'react';

const DeptCard = ({ data }) => {
    return (
        <div className="bg-green-100 shadow-md rounded-lg overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-xl">
            <img src={data.img} alt={data.name} className="w-full h-40 object-cover" />
            <div className="p-4">
                <h2 className="text-xl font-bold text-secondary">{data.name}</h2>
                <p className="text-gray-600 mt-2">{data.description.substring(0, 100)}...</p>
                <a href={data.path} className="text-primary font-semibold hover:underline block mt-2">
                    Learn More →
                </a>
            </div>
        </div>
    );
};

export default DeptCard;